export default function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    const registerSW = () => {
      navigator.serviceWorker.register('/sw.js').catch(error => {
        window.console.error('Failed to register Service Worker.');
        window.console.error(error);
      });
    };

    // previously, we only add a window "load" event listener to register the service worker.
    // however, registerServiceWorker might be called after window "load" event has been fired already,
    // which means this event listener will never be called, and the service worker will never be registered.

    // advancing the registerServiceWorker call before any awaits in `init` is enough to solve this issue.
    // the following is just safe guard to prevent this issue happening again.

    // in practice, checking `document.readyState === 'complete'` is the simplest way to know
    // if window load event was fired already:
    // https://stackoverflow.com/questions/13364613/how-to-know-if-window-load-event-was-fired-already

    // the HTML standard confirms this solution is correct.
    // load event is fired on window immediately after `document.readyState` becomes 'complete'
    // https://html.spec.whatwg.org/multipage/parsing.html#the-end:queue-a-global-task-2

    if (document.readyState === 'complete') {
      registerSW();
    } else {
      // if possible, wait until the page is fully loaded before registering the service worker.
      // this avoids bandwidth contention if the service worker precaches anything.
      window.addEventListener('load', registerSW);
    }
  }
}
